import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faAngleRight } from "@fortawesome/free-solid-svg-icons"

const CarouselNextButton = ({ onClick }) => {
  return (
    <button onClick={onClick} className="slider-arrow next" aria-label="Next">
      <FontAwesomeIcon icon={faAngleRight} />
    </button>
  )
}

export default CarouselNextButton